import { Link, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";

export function ManagerTopbar() {
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem("manager_auth");
    navigate("/manager/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-40 flex items-center justify-between border-b border-pink-100 bg-white px-6 py-4">
      <Link to="/manager" className="flex items-center gap-2">
        <Logo size={32} />
        <span className="font-display text-lg font-bold text-gray-900">Quản lý — Nhà Thỏ</span>
      </Link>
      <div className="flex items-center gap-4">
        <button
          onClick={handleSignOut}
          className="text-sm text-gray-500 transition-colors hover:text-pink-500"
        >
          Đăng xuất
        </button>
      </div>
    </header>
  );
}
